/* eslint-disable react-i18n/no-dynamic-translation-keys */
import React from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { FlexWrapper } from "../AdAssistant.styled";
import { SaveDataButton } from "./SaveNavigation.styled";
import { SaveDataIcon } from "../../../Components/Icons";
import ContinueButton from "../../../Components/ContinueButton/ContinueButton";
import { useUrlBasedStep } from "../hooks/useUrlBasedStep";
import { Spinner } from "../../../Components/Upload/Upload.styled";
import AdAssistantStore from "../AdAssistantStore";
import { withRefluxStore } from "../../../Stores";
import { checkCampaignStatus } from "../utils";

const SaveNavigation = ({
  selectedItems,
  emitSaveCampaign,
  navigationUrl,
  navigationText,
  emitCampaignCreation = null,
  isLoading = false,
  // Store
  usedAds,
  campaignData,
  isBooked,
  // Router
  history,
  location
}) => {
  const MIN_USED_ADS = 3;
  const { stepName } = useUrlBasedStep({ location });
  const { t } = useTranslation();

  const disableNavigation = usedAds.length < MIN_USED_ADS;

  const handleContinue = () => {
    if (stepName === "checkout") {
      emitCampaignCreation();
    }

    const newStatus = checkCampaignStatus(campaignData);
    history.push(navigationUrl);
    emitSaveCampaign({ status: newStatus });
  };

  const handleSave = () => {
    const newStatus = checkCampaignStatus(campaignData);
    emitSaveCampaign({ status: newStatus });
  };

  return (
    <FlexWrapper gap={10} justify="flex-end" width="100%">
      <SaveDataButton onClick={handleSave}>
        <SaveDataIcon color={selectedItems > 0 ? "#1E22FF" : "#ABB4F4"} />
      </SaveDataButton>
      {!isBooked && (
        <ContinueButton
          onClick={handleContinue}
          color={disableNavigation ? "#ABB4F4" : "#fff"}
          backgroundColor={disableNavigation ? "#D4D8F9" : "#1E22FF"}
          isDisabled={disableNavigation}
        >
          {isLoading ? <Spinner /> : t(navigationText)}
        </ContinueButton>
      )}
    </FlexWrapper>
  );
};

export default withRouter(
  withRefluxStore(SaveNavigation, [AdAssistantStore], ["usedAds", "campaignData", "isBooked"])
);
